import { render, staticRenderFns } from "./PedidoDetalhe.vue?vue&type=template&id=6a1287ba&scoped=true&"
import script from "./PedidoDetalhe.vue?vue&type=script&lang=js&"
export * from "./PedidoDetalhe.vue?vue&type=script&lang=js&"
import style0 from "./PedidoDetalhe.vue?vue&type=style&index=0&id=6a1287ba&prod&scoped=true&lang=scss&"


/* normalize component */
import normalizer from "!../../../../../../../../../frontend/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "6a1287ba",
  null
  
)

export default component.exports